export const Routes = {
  HOME: '/'
}
